import script from "./PastDocumentationGoal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastDocumentationGoal.vue?vue&type=script&setup=true&lang=ts"

import "./PastDocumentationGoal.vue?vue&type=style&index=0&id=15ea48c2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ea48c2"]])

export default __exports__